// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3if6W","title":"Images45_title__2hwdz","images":"Images45_images__nau_v"};